import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RecaptchaComponent, RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { ContactFormService } from './contact-form.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        ToastModule,
    ],
    providers: [MessageService]
})
export class ContactFormComponent implements OnInit {

    contactForm: FormGroup;
    submitted = false;
    recaptchaKey = environment.recaptcha_site_key;
    @ViewChild('captchaRef') captchaRef?: RecaptchaComponent;
    private isProgrammaticCaptchaReset = false;

    constructor(
        private fb: FormBuilder,
        private contactFormService: ContactFormService,
        private messageService: MessageService,
    ) {
        this.contactForm = this.fb.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', [Validators.required, Validators.pattern(new RegExp("[- +()0-9]{10,16}"))]],
            company: [''],
            partnership: ['', Validators.required],
            message: [''],
            recaptcha: ['']
        });
    }

    ngOnInit(): void {
    }

    onSubmit(): void {
        this.submitted = true;
        if (this.contactForm.invalid) {
            this.contactForm.markAllAsTouched();
            return;
        }

        // Avvio reCAPTCHA invisibile
        this.captchaRef?.execute();
    }

    resetForm():void {
        this.submitted = false;
        this.contactForm.reset();
    }

    onCaptchaResolved(token: string | null): void {
        // 1) Ignora l'evento che arriva dal reset manuale
        if (this.isProgrammaticCaptchaReset) {
            this.isProgrammaticCaptchaReset = false;
            return;
        }

        // 2) Nessun token (utente ha chiuso / captcha scaduto / reset da Google)
        if (!token) {
            this.contactForm.get('recaptcha')?.reset({ emitEvent: false });
            return;
        }

        this.contactForm.patchValue({ recaptcha: token }, { emitEvent: false });

        // 🔹 Ora puoi inviare il form al backend
        console.log('FORM VALIDATO + TOKEN CAPTCHA:', this.contactForm.value);
        this.contactFormService.submitBusinessContact(this.contactForm.value).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Message sent',
                    detail: 'We will get back to you shortly.'
                });
                this.resetForm();
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Submission failed',
                    detail: 'Please try again later.'
                });
                this.resetCaptcha();
            }
        });
    }

    private resetCaptcha(): void {
        this.isProgrammaticCaptchaReset = true;

        this.contactForm.get('recaptcha')?.reset({ emitEvent: false });
        this.captchaRef?.reset();
    }
}
